import { gql } from "@apollo/client";

export const COMMERCIAL_FILTER_QUERY = gql`
    query CommercialFilter {
        companies {
            items {
                key
                name
            }
        }
        channels {
            items {
                key
                name
            }
        }
        subBrands {
            items {
                key
                name
            }
        }
        brands {
            items {
                key
                name
            }
        }
        categories {
            items {
                key
                name
            }
        }
        routeToMarkets {
            items {
                key
                name
            }
        }
    }
`;


